import {
    CREATE_UPLOAD_FAQ_SUCCESS,
    CREATE_UPLOAD_FAQ_ERROR,
    CREATE_UPLOAD_FAQ_REQUEST,


    CREATE_TOPIC_QUESTION_LIST_SUCCESS,
    CREATE_TOPIC_QUESTION_LIST_ERROR,
    CREATE_TOPIC_QUESTION_LIST_REQUEST,


    CREATE_EDIT_FAQ_QUES_LIST_SUCCESS,
    CREATE_EDIT_FAQ_QUES_LIST_ERROR,
    CREATE_EDIT_FAQ_QUES_LIST_REQUEST,


    DELETE_QUES_LIST_SUCCESS,
    DELETE_QUES_LIST_ERROR,
    DELETE_QUES_LIST_REQUEST,




    UPDATE_PARENT_QUES_LIST_SUCCESS,
    UPDATE_PARENT_QUES_LIST_ERROR,
    UPDATE_PARENT_QUES_LIST_REQUEST




}  from "../../Types/user/Types";


const initialState = {
    error: "",
    create_upload_faq_data: "",
    create_topic_ques_list_data:"",
    create_quest_list_data:"",
    delete_ques_list_data:"",
    edit_parent_ques_list_data:"",
    loader: false,
  };


  export const create_upload_faq_Reducer = (state = initialState, action) => {
    switch (action.type) {
      case CREATE_UPLOAD_FAQ_SUCCESS:
        return {
          ...initialState.create_upload_faq_data,
          error: "",
          create_upload_faq_data: action.payload,
          loader: false,
        };
      case CREATE_UPLOAD_FAQ_ERROR:
        return {
          ...initialState.create_upload_faq_data,
          error: action.error,
          create_upload_faq_data: "",
          loader: false,
        };
      case  CREATE_UPLOAD_FAQ_REQUEST:
        return {
          ...initialState.create_upload_faq_data,
          error: null,
          create_upload_faq_data: action.payload,
          loader: true,
        };
      default:
        return state;
    }
  };




  export const create_get_topic_ques_list_Reducer = (state = initialState, action) => {
    switch (action.type) {
      case CREATE_TOPIC_QUESTION_LIST_SUCCESS:
        return {
          ...initialState.create_topic_ques_list_data,
          error: "",
          create_topic_ques_list_data: action.payload,
          loader: false,
        };
      case CREATE_TOPIC_QUESTION_LIST_ERROR:
        return {
          ...initialState.create_topic_ques_list_data,
          error: action.error,
          create_topic_ques_list_data: "",
          loader: false,
        };
      case  CREATE_TOPIC_QUESTION_LIST_REQUEST:
        return {
          ...initialState.create_topic_ques_list_data,
          error: null,
          create_topic_ques_list_data: action.payload,
          loader: true,
        };
      default:
        return state;
    }
  };



  export const create_ques_list_Reducer = (state = initialState, action) => {
    switch (action.type) {
      case CREATE_EDIT_FAQ_QUES_LIST_SUCCESS:
        return {
          ...initialState.create_quest_list_data,
          error: "",
          create_quest_list_data: action.payload,
          loader: false,
        };
      case CREATE_EDIT_FAQ_QUES_LIST_ERROR:
        return {
          ...initialState.create_quest_list_data,
          error: action.error,
          create_quest_list_data: "",
          loader: false,
        };
      case  CREATE_EDIT_FAQ_QUES_LIST_REQUEST:
        return {
          ...initialState.create_quest_list_data,
          error: null,
          create_quest_list_data: action.payload,
          loader: true,
        };
      default:
        return state;
    }
  };


  export const delete_ques_list_Reducer = (state = initialState, action) => {
    switch (action.type) {
      case DELETE_QUES_LIST_SUCCESS:
        return {
          ...initialState.delete_ques_list_data,
          error: "",
          delete_ques_list_data: action.payload,
          loader: false,
        };
      case DELETE_QUES_LIST_ERROR:
        return {
          ...initialState.delete_ques_list_data,
          error: action.error,
          delete_ques_list_data: "",
          loader: false,
        };
      case  DELETE_QUES_LIST_REQUEST:
        return {
          ...initialState.delete_ques_list_data,
          error: null,
          delete_ques_list_data: action.payload,
          loader: true,
        };
      default:
        return state;
    }
  };




  export const update_parent_ques_list_Reducer = (state = initialState, action) => {
    switch (action.type) {
      case UPDATE_PARENT_QUES_LIST_SUCCESS:
        return {
          ...initialState.edit_parent_ques_list_data,
          error: "",
          edit_parent_ques_list_data: action.payload,
          loader: false,
        };
      case UPDATE_PARENT_QUES_LIST_ERROR:
        return {
          ...initialState.edit_parent_ques_list_data,
          error: action.error,
          edit_parent_ques_list_data: "",
          loader: false,
        };
      case  UPDATE_PARENT_QUES_LIST_REQUEST:
        return {
          ...initialState.edit_parent_ques_list_data,
          error: null,
          edit_parent_ques_list_data: action.payload,
          loader: true,
        };
      default:
        return state;
    }
  };